module.exports = __webpack_public_path__ + "img/shortcut.d575cb9e.svg";